import React, { useEffect, useState } from 'react'
import AppHeader from '../components/AppHeader'

import useSystemMasterList from '../../../hooks/useSystemMasterList';
import UserComplaintList from '../components/UserComplaintList';
import { Link } from 'react-router-dom';
import { Check } from '@mui/icons-material';

function ComplaintListPage() {
    const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);
    const [customerPhoneNo, setCustomerPhoneNo] = useState(sessionStorage.customerPhoneNo);
    const [phoneInput,setPhoneInput] = useState(sessionStorage.customerPhoneNo);

    const doSearch = () =>{
        if(phoneInput.length == 10) {
            sessionStorage.setItem("customerPhoneNo",phoneInput)
            setCustomerPhoneNo(phoneInput)
        }
    }


    const handlePhoneInput = (e) => {
        let val = e.target.value;
        if(val.length <= 10) {
            setPhoneInput(val)
        }
    }

    return (
        <>
            <AppHeader/>
            <div className='container'>
                <div className='text-center'>
                    <Link to={"/portal"} className='btn btn-outline-primary'>Create New Complaint </Link>
                </div>
                
                {customerPhoneNo ?

                    <div className='col-md-12'>
                            <h6 className='my-4'>Complaint registed By Phone No " {customerPhoneNo} " <button type='button' onClick={()=>setCustomerPhoneNo(null)}  className='btn btn-link'>Change</button> </h6>
                            
                    </div>
                    :

                    <div className='row'>
                        
                        <div className='col-md-12'>
                            <div className='input-group my-3'>
                                <input type="number" className="form-control" placeholder="Your Phone Number"
                                    value={phoneInput}
                                    onChange={handlePhoneInput}
                                    onKeyUp={ (e) =>{
                                        if(e.key === 'Enter') {
                                            e.preventDefault();
                                            doSearch();
                                        }
                                    }}            
                                />
                                <button className='btn btn-outline-success'><Check/></button>
                            </div>
                        </div>
                    </div>
                }

                {customerPhoneNo && customerPhoneNo.length === 10 &&
                    <UserComplaintList masters={masters} getMasterLabel={getMasterLabel} customerPhoneNo={customerPhoneNo} />    
                }
                
            </div>
        </>
    )
}

export default ComplaintListPage